/**
 * i18n Engine — Tempora v2.0
 *
 * Centralizes all internationalization configuration.
 * - Auto-detects browser/OS language on first visit
 * - Persists user choice in localStorage
 * - Falls back to Spanish ('es') if a key is missing in the active locale
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import es from './locales/es.json'
import en from './locales/en.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    // Default language — Spanish
    fallbackLng: 'es',
    // Supported languages
    supportedLngs: ['es', 'en'],
    // Detection order: localStorage → browser navigator → default
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'tempora_language',
    },
    interpolation: {
      // React already escapes values, no need for i18next to do it too
      escapeValue: false,
    },
    // Disable debug mode in production
    debug: import.meta.env.DEV,
  })

export default i18n
